import { atom, RecoilState } from 'recoil';


export const checkedIds: RecoilState<string[]> =
  atom<string[]>({
    key: 'usade-details-row-id',
    default: []
  });